import React from 'react';
import { MailIcon, MessageSquareTextIcon, PhoneIcon } from 'lucide-react';
import { Reveal } from '../ui/Reveal';
import { ContactForm } from '../ui/ContactForm';
import { contactInfo } from '../../data/site';
import type { Interest } from '../../types/contact';
type ContactSectionProps = {
  interest: Interest | '';
  onInterestChange: (value: Interest | '') => void;
};
const channelClass = 'group flex items-center gap-4 rounded-2xl py-3 text-white transition-colors duration-150 ease-out hover:text-brand-accent';
const iconWrap = 'flex h-[clamp(2.75rem,3vw,3.75rem)] w-[clamp(2.75rem,3vw,3.75rem)] shrink-0 items-center justify-center rounded-full bg-white/10 text-brand-accent';
export function ContactSection({
  interest,
  onInterestChange
}: ContactSectionProps) {
  return <section id="contact" aria-labelledby="contact-heading" className="bg-brand-slate" data-id="element-71" data-mp="1dbrhxrs64q7v">
      <div className="px-fluid py-section grid gap-fluid lg:grid-cols-12" data-id="element-72" data-mp="18dg83h1vifpn">
        <Reveal className="lg:col-span-5" data-id="element-73" data-mp="18b3koodcjd57">
          <h2 id="contact-heading" className="text-h2 font-extrabold text-white" data-id="element-74" data-mp="3lj4v43uv7u3r">
            Let’s Talk
          </h2>
          <p className="text-lead mt-[clamp(1.25rem,2vw,2.25rem)] max-w-[36ch] text-white/85" data-id="element-75" data-mp="3qi7pmud7yhxh">
            Speaking, consulting or partnering — tell me what you’re working on and I’ll get back to you.
          </p>
          <ul className="mt-[clamp(2rem,3.5vw,4rem)] space-y-2 text-[clamp(1.05rem,0.9rem+0.5vw,1.6rem)] font-bold" data-id="element-76" data-mp="3e1ky4q1krwh">
            <li data-id="element-77" data-mp="89z1ab1b1y99">
              <a href={contactInfo.phoneHref} className={channelClass} data-id="element-78" data-mp="dawee97gk23w">
                <span className={iconWrap} data-id="element-79" data-mp="d8ti57fppcqq">
                  <PhoneIcon className="h-[42%] w-[42%]" aria-hidden="true" data-id="element-80" data-mp="i136wk53c6rf" />
                </span>
                {contactInfo.phoneDisplay}
              </a>
            </li>
            <li data-id="element-81" data-mp="r2b3mxrykzje">
              <a href={contactInfo.emailHref} className={`${channelClass} break-all`} data-id="element-82" data-mp="r2t5c9xe45yp">
                <span className={iconWrap} data-id="element-83" data-mp="w14esjjrwege">
                  <MailIcon className="h-[42%] w-[42%]" aria-hidden="true" data-id="element-84" data-mp="w1xej0kbe3p1" />
                </span>
                {contactInfo.email}
              </a>
            </li>
            <li data-id="element-85" data-mp="2o3gtux2ps9px">
              <a href={contactInfo.smsHref} className={channelClass} data-id="element-86" data-mp="2o3ysg0cun010">
                <span className={iconWrap} data-id="element-87" data-mp="31uvfzcrx4r17">
                  <MessageSquareTextIcon className="h-[42%] w-[42%]" aria-hidden="true" data-id="element-88" data-mp="31vwr1h8xpdix" />
                </span>
                <span data-id="element-89" data-mp="2x2ale916u9wm">
                  Text <span className="text-brand-accent" data-id="element-90" data-mp="3bsi0cerzlask">START</span> to {contactInfo.phoneDisplay}
                </span>
              </a>
            </li>
          </ul>
        </Reveal>
        <Reveal delay={0.06} className="lg:col-span-7" data-id="element-91" data-mp="36vriblwmg54i">
          <ContactForm interest={interest} onInterestChange={onInterestChange} data-id="element-92" data-mp="3ks4x2n9rtsfa" />
        </Reveal>
      </div>
    </section>;
}